import { useMemo } from 'react';

import {
  COMMERCIAL,
  ENGINEERING_NETWORKS,
  FURNISHING_SUPERVISOR,
  HEAD_EN,
  HEAD_OVP,
  OBSERVER,
  PARTNER,
  PLANNER,
  PRIME_CONTRACTOR,
  HOUSING_CONTRACTOR,
  SUPERVISOR,
  USK_PRE_ACCEPTANCE,
} from 'consts';
import { ROLE_MENU_PERMISSIONS } from 'consts/permissions/menu';

import { useAppSelector } from 'hooks';

import { filterEnvironment, filterMenu, sortMenu } from 'layout/utils';

import { NavigationItem } from '@10d/tend-ui-header';
import { Profile } from 'types';
import { Submenu } from '../types';

export const useMenu = (profile: Profile, menuItems: Submenu<NavigationItem>[]) => {
  const { role, accountingType } = profile;
  const version = useAppSelector(state => state.stand.stand);

  const items = useMemo(() => {
    const arr: Submenu<NavigationItem>[] = [];

    switch (role) {
      case COMMERCIAL:
      case ENGINEERING_NETWORKS:
      case FURNISHING_SUPERVISOR:
      case HEAD_EN:
      case HEAD_OVP:
      case OBSERVER:
      case PARTNER:
      case PLANNER:
      case SUPERVISOR:
      case HOUSING_CONTRACTOR:
      case USK_PRE_ACCEPTANCE:
        arr.push(...Do(menuItems, ROLE_MENU_PERMISSIONS[role], version));
        break;
      case PRIME_CONTRACTOR:
        arr.push(...Do(menuItems, ROLE_MENU_PERMISSIONS[role](accountingType), version));
        break;
      default:
        break;
    }

    return arr;
  }, [accountingType, menuItems, role, version]);

  return items;
};

// TODO заменить функцию на compose
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function Do(menuItems: Submenu<NavigationItem>[], rolePermissions: string[], version: any) {
  const arr = filterMenu(menuItems, rolePermissions);
  const arr2 = filterEnvironment(arr, version);
  const sorted = sortMenu(arr2, rolePermissions);
  return sorted;
}
